const TEST_MODE = true; // switch between Testing and Production

export const environment = {
  production: true,
  VERSION: require('../../package.json').version,
  packageDate: '20260916',
  testMode: TEST_MODE, // toggle this true for local machine dev
  PROD_API_SERVER_ADDRESS: 'https://danville-api.azurewebsites.net',
  TESTING_API_SERVER_ADDRESS: 'https://danville-api-testing.azurewebsites.net',
  appInsights: {
    instrumentationKey: 'bfbd9060-214b-4ebd-936f-4f9deea94f3c'
  },
  FORTE_SCRIPT_URL: TEST_MODE ? "https://sandbox.forte.net/checkout/v2/js" : 'https://checkout.forte.net/v2/js',
  MANIFEST_LENGTH_OVERRIDE: 90,
  useDebugSerialConnection: false,
  CLOVER_APP_MARKET_LINK: TEST_MODE ? 'https://sandbox.dev.clover.com/appmarket/apps/E9SK3MHQ0XMPP' : 'https://www.clover.com/appmarket/apps/HD9639SRBJJGY'
};
